import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import createWebStorage from "redux-persist/es/storage/createWebStorage";
const storage = createWebStorage("local");
import { setReducer } from "./reducer";
import { remindersReducer } from "./remindersReducer/remindersReducer";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  setReducer,
  reminders: remindersReducer,
});

export default persistReducer(persistConfig, rootReducer);
